import React from "react";
import { Redirect } from "react-router-dom";
const NotFound = () => <Redirect push to="/" />;

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js